import React from 'react';
import Modal from "../../components/Modal";
import PropTypes from 'prop-types';
import "./ModalLoginRequerido.css";
import {oidc_authorize} from "../../security/OidcManager";
import * as HttpService from "../../support/HttpService";

const ModalLoginRequerido = (props) => {

    const login = () => {
        if (props.preRedirectAction) {
            props.preRedirectAction();
        }
        oidc_authorize(HttpService.history.location.pathname);
    }

    return (
        <Modal handleClose={props.handleOnClose} isOpen={props.isOpen}
               className="modal" modalContentClassName="modal-content modal-login-requerido" closeClassName="close-modal">
            <div className="modal-login-requerido-body">
                <p className="modal-login-requerido-texto">
                    {props.modalMessage ?? 'Debe ingresar al sitio con una cuenta Antel para continuar con la compra'}
                </p>
            </div>

            <div className="modal-login-requerido-footer">
                <button type="button" className="btn btn-secondary" onClick={props.handleOnClose}>
                    <span>Cancelar</span>
                </button>

                <button type="button" className="btn btn-primary" onClick={login}>
                    <span>{props.okModalMessage ?? 'Continuar con la compra'}</span>
                </button>
            </div>
        </Modal>
    );
}

ModalLoginRequerido.propTypes = {
    handleOnClose: PropTypes.func.isRequired,
    modalMessage: PropTypes.string,
    okModalMessage: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    preRedirectAction: PropTypes.func
};

export default ModalLoginRequerido;